import {
  getAprooverContracts,
  getInspectorContracts,
  getProveedores,
  getProvidersForAproover
} from '../../../services/adminContracts';
import { getUbicationsOyM, getWellsByUnitBussines } from '../../../services/yclickMaster';
import { ubicationTypeEnum } from '../../../utils/dataStatus';

// Body formatters

// Fetch providers:
const bodyMakerToGetProviders = (value, contratosIds) => ({
  numerosContratos: contratosIds?.length
    ? contratosIds?.map((contrato) => Number(contrato?.nombre))
    : [],
  nombreProveedor: value
});

// Fetch Contracts:
const bodyMakerToGetContracts = (value, idsProveedores) => ({
  numeroContrato: value,
  proveedoresIds: idsProveedores?.length ? idsProveedores?.map((proveedor) => proveedor?.id) : []
});

// ------------------------------------------------------------>

export const fetchInspectorContracts = async (value, idsProveedores) => {
  if (value.length < 3) return null;
  const body = bodyMakerToGetContracts(value, idsProveedores);
  const { data } = await getInspectorContracts(body);

  return data;
};

export const fetchAprooverContracts = async (value, idsProveedores) => {
  if (value.length < 3) return null;
  const body = bodyMakerToGetContracts(value, idsProveedores);
  const { data } = await getAprooverContracts(body);

  return data;
};

export const fetchProveedores = async (value, contratosIds) => {
  if (value.length < 3) return null;
  const body = bodyMakerToGetProviders(value, contratosIds);
  const { data } = await getProveedores(body);

  return data;
};

export const fetchProvidersForAproover = async (value, contratosIds) => {
  if (value.length < 3) return null;
  const body = bodyMakerToGetProviders(value, contratosIds);
  const { data } = await getProvidersForAproover(body);

  return data;
};

export const fetchLocations = async (value, tipoUbicacionId, userBusinessUnits) => {
  if (value.length < 3) return null;
  let promise;

  if (tipoUbicacionId.id === ubicationTypeEnum.pozo) {
    promise = () => getWellsByUnitBussines(value, userBusinessUnits);
  } else {
    promise = () =>
      getUbicationsOyM({
        tipoUbicacionId: tipoUbicacionId.id,
        operacionId: null,
        nombre: value
      });
  }

  const data = await promise();

  return data;
};
